import { createAsyncThunk } from "@reduxjs/toolkit";
import { appName } from "../../constants/defaultValues"

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  notification
} from "../actions";

export const getCustomerInvoices = createAsyncThunk("getCustomerInvoices", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.get(`/v1/users/${payload.customerId}/invoices?sort_by=date&limit=${payload.limit}`);
    if (response.status === 200 && response.data) {
      return response.data
    } else {
      console.log("response: ", response.data)
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})


export const downloadInvoice = createAsyncThunk("downloadInvoice", async (payload, thunkAPI) => {
  try {
    let response = await axiosChargebee.get(`/v1/invoices?invoice_id=${payload}`);
    if (response && response.data && response.data.success) {
      return response.data
    }else{
      //something failed
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})